import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Pipe } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PowerBIService } from 'src/app/services/power-bi/power-bi.service';
import { PowerbiModalComponent } from 'src/app/shared/components/modals/powerbi-modal/powerbi-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';

@Component({
  selector: 'app-report-bi-historical-iot',
  templateUrl: './report-bi-historical-iot.component.html',
  styleUrls: ['./report-bi-historical-iot.component.css']
})
export class ReportBiHistoricalIOTComponent implements OnInit, OnDestroy {
  url: SafeResourceUrl;
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  enabledRead: number;
  enabledWrite: number;
  showIframe = true;
  private refreshInterval: any;
  iframeKey: string = 'initial-key';

  constructor(
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private powerBIService: PowerBIService
  ) {
    const titleHeaderNav = document.getElementById("titleHeaderNav");
    if (titleHeaderNav) {
      titleHeaderNav.innerHTML = 'IOT > <span class="font-weight-bold">Reporte Histórico Power BI</span>';
    }
  }

  ngOnInit() {
    this.setLS();
    this.enterpriseSelect = +localStorage.getItem(AppConstants.Session.ENTERPRISE);
    this.headquarterSelect = +localStorage.getItem(AppConstants.Session.HEADQUARTER);
    this.getPowerBI();
    // Refrescar cada 5 minutos (300000 ms)
    this.refreshInterval = setInterval(() => {
      this.refreshIframe();
    }, 300000);
  }

  setLS() {
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    // Validate permissions menu
    const menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    const page = this.router.url.split("/");
    const i = page[page.length - 1];
    const itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if (itemTag.length > 0) {
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    } else {
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  getPowerBI() {
    this.spinner.show();
    this.powerBIService.getListAll(this.enterpriseSelect, this.headquarterSelect, 2).subscribe(
      (response) => {
        if (response.data.length > 0) {
          this.url = this._sanitizer.bypassSecurityTrustResourceUrl(response.data[1].url);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  refreshIframe() {
    // Oculta el iframe, espera 100ms y vuelve a mostrarlo para forzar recarga
    this.showIframe = false;
    setTimeout(() => {
      this.getPowerBI();
      this.showIframe = true;
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  openAddModal() {
    let dialogRef = this.dialog.open(PowerbiModalComponent, {
      data: {
        title: AppConstants.TitleModal.POWER_BI,
        action: AppConstants.OperationType.ADD,
        idSystem: 2,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        color: this.color1,
        colorFont: this.color2,
        obj: null
      },
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_ && _.result === true) {
        window.location.reload();
      }
    });
  }
}
